<template>
  <AppSelect
    :items="toSelectItems(OPTIONS)"
    :label="$tt('sex')"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
import { toSelectItems } from '~/helpers/general';
import type { Sex } from '~/types';

const { required } = useValidation();
const { tt } = useLocalization();

const OPTIONS: Record<Sex, string> = {
  m: tt('male'),
  f: tt('female')
};
</script>